export default __webpack_public_path__ + "static/media/firebase2.e41aed9d.png";